import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SyncDialogComponent } from '../components/dialogs/sync-dialog/sync-dialog.component';
import { PlayerStatus } from '../store/entities';
import { TranslateService } from '@ngx-translate/core';
import { NgRedux } from '@angular-redux3/store';
import {
  AFetchBlacklist,
  AFetchEvents,
  AFetchFamilies, AFetchFavorites,
  AFetchHistories,
  AFetchHistory,
  AFetchSchedule,
  AFetchWishlist,
  ALogout,
  ASetMessage,
  ASetPlayer, eventsSubjects,
  PlaylistRemoteAppState, sseApi
} from '../store';
import { AFetchPlaylistMw } from '../store/actions/playlists-mw.action';
import { environment } from '../../environments/environment';
import { DesktopService } from './desktop.service';
import { OfflineService } from './offline.service';

export interface StatusSse {
  timeStamp: Date;
  datas: PlayerStatus;
  message: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class SyncDialogService {
  isOffline = false;
  status: StatusSse;
  oldStatus: StatusSse;
  private dialogRef: MatDialogRef<SyncDialogComponent>;
  private command: string;
  countStatus = 0;

  constructor(public dialog: MatDialog,
              private translate: TranslateService,
              private ngRedux: NgRedux<PlaylistRemoteAppState>,
              // private _musicPlayerService: MusicPlayerService,
              private offlineService: OfflineService,
              private _desktopService: DesktopService) {
    this.listenSSE();
  }

  openSyncDialog(command?: string) {
    this.oldStatus = JSON.parse(localStorage.getItem('SSE'));
    this.command = command;
    if (this.dialogRef) {
      return;
    }
    this.dialog.closeAll();
    this.isOffline = false;

    this.dialogRef = this.dialog.open(SyncDialogComponent, {
      disableClose: true,
      data: {
        title: this.translate.get('dialog.wait'),
        spinner: true
      }
    });
    this.getStatus();
    this.dialogRef.afterClosed().subscribe(
      () => {
        this.dialogRef = undefined;
        this.countStatus = 0;
      }
    );
  }


  private getStatus() {
    if (environment.enableDesktopMode) {
      this._desktopService.getStatus().subscribe({
          next: message => {
            if (this.isOffline) {
              this.isOffline = false;
              this.dialog.closeAll();
            }
            if (message?.datas?.fading) {
              return;
            }
            const event = new CustomEvent('player-status', { detail: { data: message } });
            localStorage.setItem('SSE', JSON.stringify(message));
            const player = localStorage.getItem('playerId');
            const resort = localStorage.getItem('resortId');
            document.dispatchEvent(event);
            if (eventsSubjects.get('/sse-status/' + player + '/' + resort + '?ngsw-bypass=true')) {
              eventsSubjects.get('/sse-status/' + player + '/' + resort + '?ngsw-bypass=true').next(message);
            } else {
              sseApi.startStatus('/sse-status/' + player + '/' + resort + '?ngsw-bypass=true');
            }
         },
          error: error => {
            this.isOffline = true;
            this.command = undefined;
         }
        }
      );
      setTimeout(() => {
        if (this.command ) {
          this.countStatus ++;
          if (this.countStatus > 50) {
            this.command = undefined;
          }
          this.getStatus();
        }
        if (this.isOffline) {
          this.offlineService.handleOffline(this.dialog);
        }
      }, this.isOffline ? 30000 : 300);
    }
  }

  listenSSE() {
    document.addEventListener('player-status', (e: MessageEvent) => {
      // @ts-ignore
      if (e.detail) {
        // @ts-ignore
        if (!environment.enableDesktopMode) {
          // @ts-ignore
          this.status = JSON.parse(e.detail.data);
        } else {
          // @ts-ignore
          this.status = e.detail.data;
        }
        if (this.status.datas) {
          this.ngRedux.dispatch(ASetPlayer({
            ...this.status.datas,
            isDownloading: this.status.datas.businessStatus?.downloadStatus?.type === 'DOWNLOADING',
            isPlaying: this.status.datas.state === 'PLAYING',
            waitList: (this.status.datas.waitList || []),
            media: this.status.datas.media || {}
          }));
        }
        switch (this.command) {
          case 'NEXT':
            if (this.status.datas && this.status.datas.media) {
              if (this.status.datas.media
                && this.status.datas.media.title !== this.oldStatus.datas.media.title
                  && this.status.datas.state === 'PLAYING') {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
            }
            setTimeout(() => {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }, 10000);
            break;
          case 'PAUSE':
            if (this.status.datas && this.status.datas.state) {
              if (this.status.datas.state === 'PAUSED') {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
            }
            setTimeout(() => {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }, 10000);
            break;
          case 'PLAY':
            if (this.status.datas && this.status.datas.state) {
              if (this.status.datas.state === 'PLAYING') {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
            }
            setTimeout(() => {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }, 10000);
            break;
          case 'EVENT':
            if (this.status.datas && this.status.datas.event && this.status.datas.playerContextType ||
              this.status.datas && this.status.datas.playerContextType) {
              if (this.status.datas.state === 'PLAYING' &&
                ((this.status.datas.playerContextType === 'PLAYLIST' && this.status.datas.event !== this.oldStatus.datas.event)
                  || this.status.datas.playerContextType !== this.oldStatus.datas.playerContextType)) {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
            }
            setTimeout(() => {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }, 10000);
            break;
          case 'TEMPO':
            if (this.status.datas && this.status.datas.tempo && this.status.datas.playerContextType ||
              this.status.datas && this.status.datas.playerContextType) {
              if ((this.status.datas.playerContextType === 'MIX' && this.status.datas.tempo !== this.oldStatus.datas.tempo)
                || this.status.datas.playerContextType !== this.oldStatus.datas.playerContextType) {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
            }
            setTimeout(() => {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }, 10000);
            break;
          case 'SCHEDULE':
            if (this.status.datas  && this.status.datas.playerContextType) {
              if (this.status.datas.playerContextType === 'SCHEDULE_WEEKLY'
                && this.status.datas.playerContextType !== this.oldStatus.datas.playerContextType) {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
            }
            setTimeout(() => {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }, 10000);
            break;
          case 'MEDIA_EVENT':
            if ((this.status.datas.playerContextType === 'PLAYLIST' && this.status.datas.event !== this.oldStatus.datas.event)
              || this.status.datas.playerContextType !== this.oldStatus.datas.playerContextType ) {
              if (this.status.datas.media.title !== this.oldStatus.datas.media.title) {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
              setTimeout(() => {
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }, 10000);
            }
            break;
          case 'MEDIA_TEMPO':
            if ((this.status.datas.playerContextType === 'MIX' && this.status.datas.tempo !== this.oldStatus.datas.tempo)
              || this.status.datas.playerContextType !== this.oldStatus.datas.playerContextType ) {
              if (this.status.datas.media.title !== this.oldStatus.datas.media.title) {
                this.command = '';
                if (this.dialogRef) {
                  this.dialogRef.close();
                }
              }
            }
            setTimeout(() => {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }, 10000);
            break;
          default:
            if (this.dialogRef) {
              this.dialogRef.close();
            }
            break;
        }
        if (!this.status.datas && !this.isOffline && window.location.pathname !== '/login') {
          this.dialog.closeAll();
          this.dialog.open(SyncDialogComponent, {
            disableClose: false,
            data: {
              title: this.translate.get('dialog.offline'),
              spinner: false
            }
          });
          this.isOffline = true;
          // this._musicPlayerService.stop();
        } else if (this.status.datas && this.isOffline) {
          this.dialog.closeAll();
        }
      } else {
        this.getStatus();
      }
    });


    document.addEventListener('command', (i: MessageEvent) => {
      // @ts-ignore
      if (i.detail) {
        // @ts-ignore
        const commandsData = JSON.parse(i.detail.data);
        switch (commandsData.command) {
          case 'COMMAND_LOGOUT':
            this.ngRedux.dispatch(ALogout());
            break;
          case 'DISPLAY_MSG':
            this.ngRedux.dispatch(ASetMessage(commandsData.body));
            break;
          case 'COMMAND_REFRESH_HISTORY':
            this.ngRedux.dispatch(AFetchHistory());
            this.ngRedux.dispatch(AFetchHistories());
            break;
          case 'COMMAND_REFRESH_LIBRARY':
            this.ngRedux.dispatch(AFetchPlaylistMw());
            break;
          case 'COMMAND_REFRESH_SCHEDULE':
            this.ngRedux.dispatch(AFetchSchedule());
            break;
          case 'COMMAND_REFRESH_PLAYLIST':
            this.ngRedux.dispatch(AFetchWishlist());
            this.ngRedux.dispatch(AFetchFamilies());
            this.ngRedux.dispatch(AFetchEvents());
            break;
          case 'COMMAND_REFRESH_FAVORITE':
            this.ngRedux.dispatch(AFetchFavorites());
            break;
          case 'COMMAND_REFRESH_BLACKLIST':
            this.ngRedux.dispatch(AFetchWishlist());
            this.ngRedux.dispatch(AFetchBlacklist());
            break;
        }
      }
    });
  }
}
